import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './authShared.css';
import { useSignup } from '../hooks/useSignup';
import { useTheme } from '../ThemeContext';
import logoLight from '../images/QuiblyLight.png';
import logoDark from '../images/QuiblyDark.png';

const Register = () => {
  const { darkMode } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [localError, setLocalError] = useState(null);
  const { signup, error, isLoading } = useSignup();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError(null);

    if (password !== confirmPassword) {
      setLocalError('Passwords do not match');
      return;
    }

    if (!acceptedTerms) {
      setLocalError('You must accept the Terms of Service and Privacy Policy to create an account');
      return;
    }

    const response = await signup(email, password, acceptedTerms);
    if (response && response.status === 'PENDING') {
      navigate('/verify', { state: { email } });
    }
  };

  const displayError = localError || error;

  return (
    <div className={`authPage ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="authCard">
        <Link to="/" className="authLogoLink">
          <img src={darkMode ? logoDark : logoLight} alt="Quibly" className="authLogo" />
        </Link>

        <h1 className="authTitle">Create your account</h1>
        <p className="authSubtitle">Start tailoring resumes to every job you apply for</p>

        <form className="authForm" onSubmit={handleSubmit}>
          <div className="authField">
            <label className="authLabel" htmlFor="register-email">Email</label>
            <input
              id="register-email"
              className="authInput"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="authField">
            <label className="authLabel" htmlFor="register-password">Password</label>
            <input
              id="register-password"
              className="authInput"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Create a password"
              autoComplete="new-password"
              required
            />
          </div>

          <div className="authField">
            <label className="authLabel" htmlFor="register-confirm">Confirm password</label>
            <input
              id="register-confirm"
              className="authInput"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repeat your password"
              autoComplete="new-password"
              required
            />
          </div>

          <label className="authConsent" htmlFor="register-terms">
            <input
              id="register-terms"
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => { setAcceptedTerms(e.target.checked); setLocalError(null); }}
            />
            <span>
              I agree to the{' '}
              <Link to="/termsandconditions" target="_blank" rel="noopener noreferrer">Terms of Service</Link>
              {' '}and{' '}
              <Link to="/privacypolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
            </span>
          </label>

          {displayError && <div className="authError">{displayError}</div>}

          <button type="submit" className="authBtn solid" disabled={isLoading || !acceptedTerms}>
            {isLoading ? 'Creating account…' : 'Create account'}
          </button>
        </form>

        <p className="authFooter">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
